<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Design system components
	import { Radio } from '@Shelly/shelly-design-system';
	//Types
	import type { PeripheralDigitalSettings } from 'src/types/Peripherals';

	let className = '';
	export { className as class };

	export let settings: PeripheralDigitalSettings;
</script>

<div class={className}>
	<Radio size="m" bind:selected={settings.type} value="switch" id="radio-ecd8x1o">
		{$format('input_type_switch', {
			default: 'Switch',
		})}
	</Radio>
	<Radio size="m" bind:selected={settings.type} value="button" id="radio-mgpp913">
		{$format('input_type_button', {
			default: 'Button',
		})}
	</Radio>
</div>
